/** v2 API의 시각은 UTC다. 존이 없는 옛 응답도 UTC로 읽고, 표시는 언제나 한국 시각으로 고정한다. */
export const V2_DISPLAY_TIME_ZONE = 'Asia/Seoul';

const ZONE_RE = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

/** 서버 시각 → Date. 숫자(ms)도 받으므로 도메인 계산에서 구한 시각을 같은 규칙으로 표시할 수 있다. */
export function parseV2Timestamp(value) {
  if (value == null || value === '') return null;
  let date;
  if (value instanceof Date) date = new Date(value.getTime());
  else if (typeof value === 'number') date = new Date(value);
  else if (typeof value === 'string') {
    const normalized = value.trim().replace(' ', 'T').replace(/(\.\d{3})\d+/, '$1')
      .replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    if (!normalized) return null;
    const iso = DATE_ONLY_RE.test(normalized) ? `${normalized}T00:00:00Z`
      : (ZONE_RE.test(normalized) ? normalized : `${normalized}Z`);
    date = new Date(iso);
  } else return null;
  return Number.isNaN(date.getTime()) ? null : date;
}

const partsFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: V2_DISPLAY_TIME_ZONE,
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

export function v2KstParts(value) {
  const date = parseV2Timestamp(value);
  return date ? Object.fromEntries(partsFormatter.formatToParts(date).map(({ type, value: part }) => [type, part])) : null;
}

/** 모든 v2 화면의 출력 모양. 날짜만 있는 도메인 값(exam_date 등)은 이 함수에 넣지 않는다. */
export function formatV2Timestamp(value, format = 'dateTime') {
  const parts = v2KstParts(value);
  if (!parts) return '';
  const { year, month, day, hour, minute, second } = parts;
  switch (format) {
    case 'date': return `${year}-${month}-${day}`;
    case 'dateTimeDot': return `${year}.${month}.${day} ${hour}:${minute}`;
    case 'dateTimeDotSeconds': return `${year}.${month}.${day} ${hour}:${minute}:${second}`;
    case 'dateTimeSeconds': return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    case 'monthDay': return `${month}-${day}`;
    case 'shortDateTime': return `${month}.${day} ${hour}:${minute}`;
    case 'time': return `${hour}:${minute}`;
    default: return `${year}-${month}-${day} ${hour}:${minute}`;
  }
}

/** 한국 달력 날짜의 자정(UTC ms). D-day처럼 날짜만 비교할 때 사용한다. */
export function v2KstDayMs(value) {
  const day = formatV2Timestamp(value, 'date');
  if (!day) return null;
  const [year, month, date] = day.split('-').map(Number);
  return Date.UTC(year, month - 1, date);
}
